var map = {
	"./Hariharan.png": "./src/images/Teams/Hariharan.png",
	"./Johnharney.png": "./src/images/Teams/Johnharney.png",
	"./Nisheethbandaru.png": "./src/images/Teams/Nisheethbandaru.png",
	"./ShaaileshAdmane.png": "./src/images/Teams/ShaaileshAdmane.png",
	"./Vidya.png": "./src/images/Teams/Vidya.png",
	"./amlaan.png": "./src/images/Teams/amlaan.png",
	"./arrow left-1.svg": "./src/images/Teams/arrow left-1.svg",
	"./arrow left.svg": "./src/images/Teams/arrow left.svg",
	"./arrow right.svg": "./src/images/Teams/arrow right.svg",
	"./balajirangan-1.png": "./src/images/Teams/balajirangan-1.png",
	"./balajirangan.png": "./src/images/Teams/balajirangan.png",
	"./clarice.png": "./src/images/Teams/clarice.png",
	"./mohanrangan.png": "./src/images/Teams/mohanrangan.png",
	"./samtoddest.png": "./src/images/Teams/samtoddest.png",
	"./shervinshahryari.png": "./src/images/Teams/shervinshahryari.png",
	"./vaibhavshah.png": "./src/images/Teams/vaibhavshah.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/images/Teams sync recursive ^\\.\\/.*$";